import { useEffect, useState } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { fetchWrapper } from '../lib/MayzSmartDB';

const CURRENT_VERSION_KEY = 'app_version';

export default function useVersionCheck() {
    const [isOutdated, setIsOutdated] = useState(false);
    const [latestVersion, setLatestVersion] = useState<string | null>(null);
    const [storedVersion, setStoredVersion] = useLocalStorage(CURRENT_VERSION_KEY, null);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                // Fetch the latest version from the server
                const response = await fetchWrapper('/version.json');
                const data = await response.json();
                const latestVersion = data.version;
                setLatestVersion(latestVersion);
                console.log (`[VERSION] latestVersion: ${latestVersion}`);
                // If versions don't match, show update message
                if (storedVersion !== null && storedVersion !== latestVersion) {
                    setIsOutdated(true);
                    setStoredVersion(latestVersion);
                } else{
                    setStoredVersion(latestVersion);
                }
            } catch (error) {
                console.error('Error checking version:', error);
            }
        };

        checkVersion();
    }, []);

    return { isOutdated, latestVersion };
}
